export enum OperationType {
    BUY = 'compra',
    SALE = 'venta'
}